import React from 'react';

//components
import BasicTextInput from '../../../../global/textInputs/BasicTextInput';
import ElementTypeInformation from '../../elements/ElementTypeInformation';
import UpDownButtonPanel from '../../../../global/buttons/buttonPanels/MoveUpMoveDownPanel';
import { IconLibrary, ThriveIcon } from '../../../..';

//interfaces
import { FormElementType, IEditFormElementWidget, ValidationRules } from '../../../interfaces/IFormElement';
import BasicButton from '../../../../global/buttons/BasicButton';



const EditElementDetails = (
    {
        elementType, 
        labelText, 
        setLabelText, 
        isRequiredElement, 
        isFirstElement, 
        isLastElement, 
        formElementComponent, 
        onMoveElementUp, 
        onMoveElementDown,
        rulesComponent,
        onSaveClick,
        onDeleteElementClick,
        conditionalCheckboxPanel,
        advancedOptions,
        validationErrors
    }: IEditFormElementWidget ) => {

    const titleIsInvalid = validationErrors?.includes(ValidationRules.TITLE_IS_REQUIRED);
    
    const hasValidationErrors = (validationErrors?.length ?? 0) >= 1;

    const titleMaxLength = [
        FormElementType.FILE_SELECT,
        FormElementType.IMAGE_SELECT,
        FormElementType.VIDEO_SELECT
    ].includes(elementType)  ? 20 : 512

    function showValidationError(label: string) {
        return (titleIsInvalid && !label.trim()) || label.length >= 513
    }

    return (
        <div className={`form-element-edit-details-wrapper ${hasValidationErrors ? 'form-validation-errors' : ''}`}>
            <div className='header-panel'>
                <div className='header-details'>
                    <h3 className='header-label-text'>{labelText}{isRequiredElement ? "*" : ""}</h3>

                    <ElementTypeInformation
                        className='reversed-elements'
                        elementType={elementType}
                        withBrackets
                    />  
                </div>

                <UpDownButtonPanel 
                    upDisabled={isFirstElement} 
                    downDisabled={isLastElement} 
                    ariaLabelUp={'Move element up in the form order'} 
                    ariaLabelDown={'Move element down in the form order'} 
                    onUpClick={onMoveElementUp} 
                    onDownClick={onMoveElementDown}                   
                />
            </div>

             
            <BasicTextInput 
                className={`form-element-label-input ${showValidationError(labelText) ? 'form-builder-error' : ''}`}
                labelText={`${elementType.toUpperCase()} LABEL*`} 
                placeholderText={'Describe your input here'} 
                textString={labelText} 
                setTextString={setLabelText}
                maxLength={titleMaxLength + 1}
                autofocus
            />
            {titleIsInvalid && <span className='error-text'>Label is required</span>}
            {labelText.length > titleMaxLength &&  <span className="error-text">Please enter a maximum of {titleMaxLength} characters</span>}   
                
            {formElementComponent}

            {advancedOptions}

            {conditionalCheckboxPanel}

            {rulesComponent}

            <div className='button-panel edit-element-button-panel'>
                <BasicButton
                    ariaLabel="Remove Field from form"
                    className="full-width-remove-button"
                    content={<span><ThriveIcon iconName={IconLibrary.BIN} color='var(--thriveCharcoal)' sizeInPx='12'/> Remove Field</span>}
                    onButtonClick={onDeleteElementClick}
                />

                <BasicButton
                    ariaLabel="Done"
                    content="Done"
                    onButtonClick={onSaveClick}
                    isClassicThriveStyle
                    className='thrive-navy-style'
                />
            </div>
        </div>
    );
};

export default EditElementDetails